// eslint-disable-next-line @typescript-eslint/no-explicit-any -- callers pass heterogeneous arrays (e.g. ({} | SpecificType)[]) and expect specific return types
export const removeEmptyObjects = (array: any[]): any[] => {
  return array.filter((element) => Object.keys(element).length !== 0);
};

export const removeObjectAttributes = <T extends Record<string, unknown>>(keys: string[], object: T): Partial<T> => {
  const temp = { ...object };
  keys.forEach((key: string) => {
    delete temp[key as keyof T];
  });
  return temp;
};

export const splitAndSentenceCase = (input: string) => {
  const parts = input.split('-');
  const sentenceCaseParts = parts.map(part => {
    return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
  });
  const result = sentenceCaseParts.join(' ');
  return result;
};

export const PLATFORM_NAME = 'Amtek CMS';